import React from 'react';
import SEO from '../components/SEO';
import Contact from '../components/Contact';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <>
      <SEO
        title="Contact Us | Tech Update - Get A Free Quote"
        description="Contact Tech Update for your web and mobile development needs. Get a free quote for Android app development, web development, WordPress development, and UI/UX design services."
        keywords="contact tech update, get quote, web development quote, mobile app development quote, free consultation"
        url="https://www.gettechupdate.com/contact"
      />
      <div className="contact-page">
      <div className="contact-page-header">
        <h1>Get In Touch</h1>
        <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
      </div>
      <Contact />
    </div>
    </>
  );
};

export default ContactPage;

